let oaiSubscribers = {};

function oaiSubscribe(eventName, callback) {
  if (oaiSubscribers[eventName] === undefined) {
    oaiSubscribers[eventName] = [];
  }

  oaiSubscribers[eventName] = [...oaiSubscribers[eventName], callback];

  return function unsubscribe() {
    oaiSubscribers[eventName] = oaiSubscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function oaiPublish(eventName, data) {
  if (oaiSubscribers[eventName]) {
    const promises = oaiSubscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
